import { DismissibleTooltip } from './DismissibleTooltip'
import { InfoIcon } from './styles/InfoTooltipStyles'

interface InfoTooltipProps {
  title: string
  placement?: 'top' | 'right' | 'bottom' | 'left'
  color?: string
}

/**
 * Reusable info tooltip component with question mark icon
 * Used to provide helpful context and explanations throughout the app
 */
export function InfoTooltip({ title, placement = 'top', color }: InfoTooltipProps) {
  return (
    <DismissibleTooltip title={title} placement={placement} mouseEnterDelay={0.3}>
      <InfoIcon $color={color} />
    </DismissibleTooltip>
  )
}
